import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Icon } from "antd";
import { Jobs } from "../../../src/components/layouts/partials";
import {
    fetchCompanyDetailsById,
    followCompany,
    getAllJobs,
    fetchRelatedCompanies
} from "../../../src/store/actions";
import { redirect } from "../../../src/utils/redirect";
import { Socials } from "../../../src/components/layouts/partials/Socials";
import { nl2br } from "../../../src/utils/helpers";
import { CompanyGrid, LogoGenerator } from '../../../src/components/common';

class CompanyDetail extends Component {
    state = {
        relatedCompanies: []
    };
    static async getInitialProps(ctx) {
        const { slug } = ctx.query;
        if (slug) {
            try {
                let slugParts = slug.split('-');
                await ctx.store.dispatch(fetchCompanyDetailsById(ctx, parseInt(slugParts[slugParts.length - 1]), true, true, true));
                let { name, category_id, id, category } = ctx.store.getState().company.companyDetailPage;
                let title = name;
                if (category) {
                    title += ' | ' + category.name + ' in nepal | Rojgari Sanjal'
                }


                let relatedCompanies = await ctx.store.dispatch(fetchRelatedCompanies({
                    categoryId: category_id,
                    companyId: id
                }));

                let jobPosts = await ctx.store.dispatch(getAllJobs({ c_id: id }));
                return {
                    title: (title || 'Company Details'),
                    meta_desc: `Rojgari sanjal offer you recent jobs opening of (${name})follow ${name} for new vacancies alert everytime via email and app.`,
                    showFooter: true,
                    keywords: 'Post free Vacancy in Nepal,Free job portal in Nepal, job posting site in nepal, best job portal in nepal, no1 job portal in nepal, large job portal in nepal, find employee in nepal, how to post vacancy in Nepal, post job ads in nepal, post vacancy in nepal',
                    footerExtraPadding: 70,
                    relatedCompanies: relatedCompanies.data.data || [],
                    jobs: jobPosts.data || []
                }
            } catch (e) {
                redirect('/', ctx);
            }
        } else {
            redirect('/', ctx);
        }
    }

    createMarkup(htmlText) {
        return { __html: nl2br(htmlText) || 'Unavailable' };
    }

    render() {
        const { company, user, jobs } = this.props;
        const details = company.companyDetailPage;
        const color = ['#F6941C', '#10B04A'];

        return (<div>
            <div className="tr-breadcrumb bg-image section-before">
                <div className="container">
                    <div className="breadcrumb-info text-center">
                        <div style={{ height: 'auto', borderRadius: 0 }} className="breadcrumb-logo">
                            {details.logo !== 'https://rojal.s3.ap-south-1.amazonaws.com/rojal/logo/logo_placeholder.jpg' ? <img src={details.logo} alt="Logo"
                                className="logo" /> : <LogoGenerator height={120} name={details.name}/>}
                        </div>


                        <div className="page-title">
                            <h1 style={{
                                marginBottom: 20,
                                color: 'white'
                            }}>{details.name || 'Company Name'}</h1>
                            <p>{details.slogan}</p>
                        </div>
                    </div>
                </div>
            </div>


            <div className="job-details section-padding">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 col-lg-8">
                            <div className="job-summary section">
                                <span
                                    className="tr-title"><strong>ABOUT {details.name.toUpperCase()}
                                        {this.props.job.data.length ?
                                            <a style={{ float: 'right', fontWeight: 600, fontSize: 16 }}
                                                href="#company_jobs">
                                                <u>{this.props.job.data.length} JOB {this.props.job.data.length > 1 ? 'POSTS' : 'POST'}</u>
                                            </a> : null}
                                    </strong>
                                </span>
                                <hr />
                                <p dangerouslySetInnerHTML={this.createMarkup(details.about)} />
                            </div>


                        </div>
                        <div className="col-lg-4">
                            <div className="tr-sidebar">
                                <div className="widget cmpany-info">
                                    <h3 className="widget_title">COMPANY INFO.</h3>
                                    <ul className="tr-list">
                                        <li><span><i className="fa fa-home"
                                            aria-hidden="true" /></span>&nbsp;
                                                {details.name}
                                        </li>
                                        <li><span><i className="fa fa-map-marker"
                                            aria-hidden="true" /></span>&nbsp; {details.p_address}
                                        </li>
                                        <li><span><i className="fa fa-phone"
                                            aria-hidden="true" /></span>&nbsp; {details.phone}
                                        </li>
                                        <li><span><i className="fa fa-envelope" aria-hidden="true" /></span>&nbsp; <a
                                            href={"mailto:" + details.email}>{details.email}</a>
                                        </li>
                                        {details.domain ? <li>
                                            <span>
                                                <i className="fa fa-globe" aria-hidden="true" /></span>&nbsp;
                                                <a rel="noreferrer" target={'_blank'}
                                                href={'http://www.' + details.domain.replace(new RegExp('\\.*www.', 'gi'), '').replace(/^http?.:\/\//, '')}>{details.domain ? details.domain.toLowerCase() : 'N/A'}</a>
                                        </li> : null}
                                    </ul>
                                    <Socials socials={details.social} small={true} />
                                </div>
                            </div>
                        </div>
                    </div>
                    {jobs.length ? <div className="row">
                        <div id={'company_jobs'} className="col-12">
                            <div className="job-summary" style={{ height: '100%' }}>
                                <span
                                    className="tr-title"><strong
                                        style={{ fontWeight: 700 }}>JOB POSTS</strong> </span>
                                <hr />
                            </div>
                            <br />
                        </div>
                        <Jobs data={jobs} />
                    </div> : null}

                    <br />
                    <br />
                    {this.props.relatedCompanies.length ? <div className="row">
                        <div id={'company_jobs'} className="col-12">
                            <div className="job-summary">
                                <span
                                    className="tr-title"><strong
                                        style={{ fontWeight: 700 }}>
                                        SIMILAR COMPANIES
                                        </strong>
                                </span>
                                <hr />
                            </div>
                            <br />
                        </div>
                        {this.props.relatedCompanies.map((item, key) => {
                            return <div className="col-lg-4 col-md-6" key={key}>
                                <CompanyGrid item={item} />
                            </div>;
                        })}
                    </div> : null}
                </div>
            </div>
            {user.authCheck === false || (user.authCheck === true && user.data.ica === false) ?
                <div className="sticky_footer">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-8 hidden-sm">
                                <h3><strong>{details.name.toUpperCase()}</strong></h3>
                                <small
                                    style={{ fontSize: 14 }}>{details.category ? details.category.name : '.....'}</small>
                            </div>
                            <div className="col-lg-4">
                                <a href="#" onClick={() => {
                                    this.props.followCompany({
                                        type: details.is_followed === true ? 0 : 1,
                                        company_id: details.id
                                    });
                                }}
                                    className={`btn big-on-sm ${!details.is_followed ? 'btn-primary' : 'btn-default following_btn'}`}
                                    style={{ float: 'right' }}>{details.is_followed ? <Icon
                                        type={'check-circle'} /> : ''}{details.is_followed ? 'Following (Un Follow)' : 'Follow Company'}</a>
                            </div>
                        </div>
                    </div>
                </div> : null}
        </div>
        );
    }


    componentWillUnmount() {
    }

    componentDidMount() {
        this.props.getAllJobs({ c_id: this.props.company.companyDetailPage.id });

    }
}

const mapStateToProps = state => {
    return {
        company: state.company,
        user: state.user,
        job: state.job
    }
};


export default connect(mapStateToProps, {
    followCompany, getAllJobs, fetchRelatedCompanies
})(CompanyDetail);